<!--START: header-->
<landing-app-header></landing-app-header>
<!--END: header-->

<div class="hero-section bg-green wf-section">
  <div class="container">
    <div data-w-id="2cdd70dd-5355-c03c-80a4-d87b9928d74b" class="hero-banner">
      <div class="hero-inside-wrapper">
        <div class="_50-percent-block">
          <h1 data-w-id="28946452-b2a8-79c3-919f-ab9b4f36bb84" class="hero-title color-white">Sell online with ease using Merchloop.<br></h1>
          <div class="margin-20px">
            <p data-w-id="28946452-b2a8-79c3-919f-ab9b4f36bb8c" class="sub-heading color-white">Watch this quick video to let us show you how!<br></p>
          </div>
        </div>
        <a (click)="showVideo=!showVideo" data-w-id="1773fd31-dd51-aac7-5599-7e7783962954" class="lightbox-link w-inline-block w-lightbox">
          <img src="assets/img/play-filled.svg" width="25" alt="">
        </a>

      </div>
    </div>
  </div><img src="assets/img/scribbles-11.png" width="60" data-w-id="8e711c7f-041a-6759-08bf-a7788e088ad6" alt="" class="scribble-2"><img src="assets/img/scribbles-9.png" width="100" data-w-id="711c4154-9d9f-1ef2-acf6-16cbf103228e" sizes="(max-width: 991px) 80px, 100px" srcset="assets/img/scribbles-9-p-500.png 500w, assets/img/scribbles-9.png 718w" alt="" class="scribble-1">
</div>
<div class="section how-it-works wf-section">
  <div class="container">
    <div class="align-center">
      <div class="_70-percent-block auto">
        <h2 class="hero-title _50px">All Products Made To Order<br></h2>
      </div>
    </div>
    <div class="tab-vertical-block">
      <div data-duration-in="300" data-duration-out="100" data-current="Tab 2" data-easing="ease" class="tabs w-tabs">
        <div id="w-node-e119612a-5b73-62d1-4578-ebb73d35527d-090b5524" class="tabs-menu-2 w-tab-menu">
          <a data-w-tab="Tab 2" class="tab-feautres how-it-works w-inline-block w-tab-link w--current">
            <div class="features-content on-tab">
              <img src="assets/img/icons8-smartphone-tablet-512.png" width="50" sizes="50px" srcset="assets/img/icons8-smartphone-tablet-512-p-500.png 500w, assets/img/icons8-smartphone-tablet-512.png 512w" alt="">
              <h3>Never worry about stock again<br></h3>
              <p>By creating all products made to order you never have to worry about keeping stock again.<br></p>
            </div>
          </a>
          <a data-w-tab="Tab 3" class="tab-feautres how-it-works w-inline-block w-tab-link">
            <div class="features-content on-tab">
              <img src="assets/img/icons8-view-quilt-512.png" width="50" alt="">
              <h3>Stop guessing what people want<br></h3>
              <p>Only creating what is sold allows you to focus on what people really want and never lose money on what people don&#x27;t buy.<br></p>
            </div>
          </a>
          <a data-w-tab="Tab 4" class="tab-feautres how-it-works w-inline-block w-tab-link">
            <div class="features-content on-tab">
              <img src="assets/img/icons8-online-support-512.png" width="50" sizes="50px" srcset="assets/img/icons8-online-support-512-p-500.png 500w, assets/img/icons8-online-support-512.png 512w" alt="">
              <h3>Increase you offerings.<br></h3>
              <p>Not having to purchase stock, you can expand your offerings <br></p>
            </div>
          </a>
        </div>
        <div id="w-node-e119612a-5b73-62d1-4578-ebb73d355287-090b5524" class="w-tab-content">
          <div data-w-tab="Tab 2" class="tab-panel w-tab-pane w--tab-active">
            <div class="tab-photo photo-1"></div>
          </div>
          <div data-w-tab="Tab 3" class="tab-panel w-tab-pane">
            <div class="tab-photo photo-2"></div>
          </div>
          <div data-w-tab="Tab 4" class="tab-panel w-tab-pane">
            <div class="tab-photo photo-3"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="margin-block">
      <div class="counters-block">
        <div class="counters-grid">
          <div class="counters-content">
            <div>100+</div>
            <p class="paragraph-white">Components make any design stand out<br></p>
          </div>
          <div class="counters-content">
            <div>4+</div>
            <p class="paragraph-white">Unique hero sections that can easily be dropped into any section<br></p>
          </div>
          <div class="counters-content">
            <div>99%</div>
            <p class="paragraph-white">Strong team supporting Landkit template<br></p>
          </div>
        </div><img src="assets/img/scribbles-7.png" width="100" data-w-id="e1594acb-8c3c-5be0-cd68-975b03623b51" sizes="100vw" srcset="assets/img/scribbles-7-p-500.png 500w, assets/img/scribbles-7.png 812w" alt="" class="scribble-1">
      </div>
    </div>
  </div><img src="assets/img/scribbles-8.png" width="100" data-w-id="f0004a60-e661-494f-5e1d-adbdfe8c4fb6" sizes="100vw" srcset="assets/img/scribbles-8-p-500.png 500w, assets/img/scribbles-8-p-800.png 800w, assets/img/scribbles-8-p-1080.png 1080w, assets/img/scribbles-8-p-1600.png 1600w, assets/img/scribbles-8.png 2287w" alt="" class="scribble-3">
</div>
<div class="faq-section wf-section">
  <div class="section-overlay"></div>
  <div class="container">
    <div class="_2-column-grid">
      <div>
        <div class="_90-percent-block">
          <div class="flex-block">
            <div class="tag-text">FAQ</div>
          </div>
          <div class="margin-20px">
            <h4 class="hero-title _50px">Things people often ask about<br></h4>
          </div>
          <div class="margin-40px">
            <div>
              <div data-hover="false" data-delay="500" data-w-id="2d54fd63-ec6d-3c5f-f66a-9f9f7b63489d" class="toggle-wrapper w-dropdown">
                <div class="dropdown-toggle w-dropdown-toggle">
                  <div class="toggle-icon"><img src="assets/img/plus.png" width="10" alt="" class="plus-icon"></div>
                  <div>What is Merchloop?</div>
                </div>
                <nav class="toggle-content w-dropdown-list">
                  <p>Merchloop allows you to build a custom print on demand store within minutes and no experience required. </p>
                </nav>
              </div>
              <div data-hover="false" data-delay="500" class="toggle-wrapper w-dropdown">
                <div class="dropdown-toggle w-dropdown-toggle">
                  <div class="toggle-icon"><img src="assets/img/plus.png" width="10" alt="" class="plus-icon"></div>
                  <div>What is Print On Demand?</div>
                </div>
                <nav class="toggle-content w-dropdown-list">
                  <p>Print on demand is a manufacturing process where we make products as they are ordered! This means you don&#x27;t have to carry any inventory and you don&#x27;t have to guess anymore what the people who are purchasing want. </p>
                </nav>
              </div>
              <div data-hover="false" data-delay="500" class="toggle-wrapper w-dropdown">
                <div class="dropdown-toggle w-dropdown-toggle">
                  <div class="toggle-icon"><img src="assets/img/plus.png" width="10" alt="" class="plus-icon"></div>
                  <div>Can you integrate with my current store?</div>
                </div>
                <nav class="toggle-content w-dropdown-list">
                  <p>Yes we are able to integrate into Shopify currently. You can download our Merchloop app in the Shopify marketplace. We have plans to integrate with more ecommerce sites soon!</p>
                </nav>
              </div>
              <div data-hover="false" data-delay="500" class="toggle-wrapper w-dropdown">
                <div class="dropdown-toggle w-dropdown-toggle">
                  <div class="toggle-icon"><img src="assets/img/plus.png" width="10" alt="" class="plus-icon"></div>
                  <div>How does shipping work?</div>
                </div>
                <nav class="toggle-content w-dropdown-list">
                  <p>We ship out of our Las Vegas, NV within 3 business days of the order being placed through your store! No more worrying about fulfilling orders and you can focus on what you love!</p>
                </nav>
              </div>
              <div data-hover="false" data-delay="500" class="toggle-wrapper w-dropdown">
                <div class="dropdown-toggle w-dropdown-toggle">
                  <div class="toggle-icon"><img src="assets/img/plus.png" width="10" alt="" class="plus-icon"></div>
                  <div>How do I get started?</div>
                </div>
                <nav class="toggle-content w-dropdown-list">
                  <p>Sign up here at merchloop.com or download our Shopify app and start using today with no up front costs.</p>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="illustration"><img src="assets/img/HalftoneCircleGreen.png" data-w-id="06a473a4-8ed0-707b-e89b-fee26dafe27a" sizes="100vw" srcset="assets/img/HalftoneCircleGreen-p-500.png 500w, assets/img/HalftoneCircleGreen-p-800.png 800w, assets/img/HalftoneCircleGreen-p-1080.png 1080w, assets/img/HalftoneCircleGreen.png 1200w" alt=""></div>
    </div>
    <div class="margin-block">
      <div class="testimonials-grid">
        <div class="testimonials-block">
          <div>
            <img src="assets/img/logo-1w.png" width="120" sizes="100vw" srcset="assets/img/logo-1w-p-500.png 500w, assets/img/logo-1w-p-800.png 800w, assets/img/logo-1w-p-1080.png 1080w, assets/img/logo-1w.png 1770w" alt="">
            <div class="margin-40px">
              <p class="paragraph-white">“The Mastertheme team provides excellent support, listens to their users and continually works to improve their product”<br></p>
            </div>
            <div class="margin-20px">
              <h4 class="heading-white">John Doe, Ideaa Strategy</h4>
            </div>
          </div>
        </div>
        <div class="testimonials-block">
          <div>
            <img src="assets/img/logo-2w.png" width="130" alt="">
            <div class="margin-40px">
              <p class="paragraph-white">“The Mastertheme team provides excellent support, listens to their users and continually works to improve their product”<br></p>
            </div>
            <div class="margin-20px">
              <h4 class="heading-white">John Doe, ZooTV</h4>
            </div>
          </div>
        </div>
        <div class="testimonials-block">
          <div>
            <img src="assets/img/logo-3w.png" width="130" alt="">
            <div class="margin-40px">
              <p class="paragraph-white">“The Mastertheme team provides excellent support, listens to their users and continually works to improve their product”<br></p>
            </div>
            <div class="margin-20px">
              <h4 class="heading-white">John Doe, Codelab</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="overlay" *ngIf="showVideo"></div>
<div class="intro-video" *ngIf="showVideo">
  <button class="close-intro-video" (click)="showVideo = false">
    <i class="material-icons">close</i>
  </button>
  <iframe class="embedly-embed"
          src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fwww.youtube.com%2Fembed%2F2_lu0bfwNd0%3Ffeature%3Doembed&display_name=YouTube&url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3D2_lu0bfwNd0&image=https%3A%2F%2Fi.ytimg.com%2Fvi%2F2_lu0bfwNd0%2Fhqdefault.jpg&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=youtube"
          scrolling="no" title="YouTube embed"
          frameborder="0" allow="autoplay; fullscreen"
          allowfullscreen="true">
  </iframe>
</div>

<!--START: Footer-->
<landing-app-footer></landing-app-footer>
<!--END: Footer-->
